import React from "react";

const SquadPrePage = () => {
  return (
    <div style={{ marginTop: "-13vw" }}>
      <img src={require("../../assets/img/player/season_preparation_m@2x.png")} alt={"season_preparation_m@2x.png"} />
    </div>
  );
};

export default SquadPrePage;
